import { httpClient } from './httpClient';

const base = '/api/bonificaciones';

export const listarBonificaciones = () => httpClient.get(base);
export const crearManual = (payload) => httpClient.post(`${base}/manual`, payload);
export const actualizarBonificacion = (id, payload) => httpClient.put(`${base}/${id}`, payload);
export const registrarDescuento = (id, payload) => httpClient.patch(`${base}/${id}/descuento`, payload);
export const eliminarDescuento = (id) => httpClient.del(`${base}/${id}/descuento`);
export const abonarAMatricula = (id, payload = {}) => httpClient.post(`${base}/${id}/abonar-matricula`, payload);

const bonificacionesService = {
  listar: listarBonificaciones,
  actualizar: actualizarBonificacion,
  registrarDescuento,
  eliminarDescuento,
  abonarAMatricula,
  crearManual,
};

export default bonificacionesService;
